var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", "max-width": "320" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "primary white--text subheading" },
            [
              _vm._v(
                _vm._s(_vm.$t("askBanVisitor")) +
                  " " +
                  _vm._s(
                    _vm.datasVisiteur.visiteurName
                      ? _vm.datasVisiteur.visiteurName
                      : _vm.datasVisiteur.visiteurID
                  ) +
                  " ?"
              )
            ]
          ),
          _vm._v(" "),
          _c("v-card-text", [_vm._v(_vm._s(_vm.$t("askBanContent")))]),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "blue--text darken-1",
                  attrs: { flat: "" },
                  on: {
                    click: function($event) {
                      return _vm.$emit("closeDialog")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("cancel")))]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "blue--text darken-1",
                  attrs: { flat: "" },
                  on: {
                    click: function($event) {
                      return _vm.emitBannChat()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("banish")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-47e077ed", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47e077ed","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheebox/WzDialogBannishVisitor.vue
// module id = null
// module chunks = 